import React, { useState } from "react";
import "./qualifications.css";

const Qualifications = () => {

  const [toggleState, setToggleState] = useState(1);

  return (

    <section className="qualifications section" id="portfolio">
      <h2 className="section__title">Qualifications</h2>
      <span className="section__subtitle">My technical journey</span>

      <div className="qualification__container container">

        <div className="qualification__tabs">

          <div className={toggleState===1?"qualification__button qualification__active button--flex":"qualification__button button--flex"}  onClick={()=>setToggleState(1)}>

            <i className="uil uil-graduation-cap qualification__active qualification__icon"></i>{" "}
            Education
          </div>
          <div className={toggleState===2?"qualification__button qualification__active button--flex":"qualification__button button--flex"} onClick={()=>setToggleState(2)}>
            <i className="uil uil-briefcase-alt qualification__icon"></i>{" "}
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div className={toggleState===1?"qualification__content qualification__content-active ":"qualification__content"}>

            <div className="qualification__data">
              <div className="">
                <h3 className="qualification__title">Mobile Dev</h3>
                <span className="qualification__subtitle">Fayoum Uni</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>2021 - Present
                </div>
              </div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div className=""></div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="">
                <h3 className="qualification__title">Web Design</h3>
                <span className="qualification__subtitle">Fayoum Uni</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>2021 - Present
                </div>
              </div>
            </div>

            <div className="qualification__data">

              
              <div className="">
                <h3 className="qualification__title">Mobile Design</h3>
                <span className="qualification__subtitle">Fayoum Uni</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>2021 - Present
                </div>
              </div>


              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

            </div>

            <div className="qualification__data">

              <div className=""></div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="">
                <h3 className="qualification__title">Web Development</h3>
                <span className="qualification__subtitle">Fayoum Uni</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>2020 - Present
                </div>
              </div>

            </div>
          </div>

          <div className={toggleState===2?"qualification__content qualification__content-active ":"qualification__content"}>
            <div className="qualification__data">
              <div className="">
                <h3 className="qualification__title">Fullstack Developer</h3>
                <span className="qualification__subtitle">OWG - Oman(on-site)</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>Feb 2023 - Oct 2023
                </div>
              </div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div className=""></div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="">
                <h3 className="qualification__title">Fullstack Mobile Developer</h3>
                <span className="qualification__subtitle">Part-time - Oman(on-site)</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>Nov 2022 - Jan 2023
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div className="">
                <h3 className="qualification__title">Flutter Lead Developer</h3>
                <span className="qualification__subtitle">RGB -Egypt(on-site)</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>Feb 2022 - Oct 2022
                </div>
              </div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div className=""></div>

              <div className="">
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div className="">
                <h3 className="qualification__title">Flutter Developer</h3>
                <span className="qualification__subtitle">Codeware - Kuwait(remote) </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>Apr 2022 - Sep 2022
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default Qualifications;
